import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
@Pipe({
    name: 'formatTime',
    standalone: false
})
export class FormatTimePipe implements PipeTransform {
  /**
   * pipe to transform data in to MM/DD/YYYY or time format
   */
  transform(value: any, args?: any): any {
    const date = value.indexOf('Z') === -1 ?
      moment(value, ['MM/DD/YYYY', 'YYYY-MM-DDTHH:mm:ss.SSSS', 'YYYY-MM-DDTHH:mm:ss'], true).utc(true)
      : moment(value, ['YYYY-MM-DDTHH:mm:ss.SSSSZ', 'yyyy-mm-ddThh:mm:ss.s+zzzzzz', 'YYYY-MM-DDTHH:mm:ssZ'], true);
    return date.local().format(args);
  }
}
